/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import truncate from 'lodash/truncate';
import {
  CLOUDINARY_BASE_VALUES,
  LOCATION_IMG,
} from '../../../../../utils/constants';
import { SafePureComponent } from '../../../../../utils/SafePureComponent';
import Picture from '../../../../ui/Picture';
import PriceGenerator from '../../../../ui/PriceGenerator';
import { Breakpoints } from '../../../../../styles/Grid/GridSizes';
import * as styles from './index.styles';

export const defaultData = {
  Location: {
    Address: '',
    FallBackImage: {
      value: {
        src: LOCATION_IMG.FIRST.FALLBACK,
      },
    },
    ImageUrl: '',
    Name: '',
    Url: '',
  },
  Solution: {
    Name: '',
    Price: 0,
    Currency: '',
    PriceUnit: '',
  },
};

const baseImageSizes = {
  ...CLOUDINARY_BASE_VALUES,
  width: 232,
  height: 130,
};

const imageSizes = {
  [Breakpoints.xl]: baseImageSizes,
  [Breakpoints.lg]: baseImageSizes,
  [Breakpoints.md]: baseImageSizes,
  [Breakpoints.sm]: baseImageSizes,
};

const renderSolutionItem = solution => (
  <div>
    <span css={styles.solutionItemName}>
      <Text field={{ value: solution.Name }} editable={false} />
    </span>
    <span css={styles.solutionItemPrice}>
      <PriceGenerator price={solution} type="listing" />
    </span>
  </div>
);

const prepareSrc = (image, isBrandImage = false) => {
  if (image.value) {
    image.value.src = isBrandImage
      ? `/${get(image, 'value.src', '')}`
      : get(image, 'value.src', '');
  }
  return image;
};

export class MapCard extends SafePureComponent {
  state = {
    fields: defaultsDeep(this.props.fields, defaultData),
  };

  componentDidUpdate(prevProps) {
    if (isEqual(prevProps.fields, this.props.fields)) return;

    this.setState({
      fields: defaultsDeep(this.props.fields, prevProps.fields),
    });
  }

  safeRender() {
    const { t } = this.props;
    const { Location, Solution } = this.state.fields;

    const { Address, FallBackImage, ImageUrl, Name, Url } = Location;

    let parsedImage = !isEmpty(ImageUrl) && JSON.parse(ImageUrl);

    parsedImage = prepareSrc(parsedImage);

    return (
      <a
        data-item="result-card"
        href={Url}
        rel="noopener noreferrer"
        css={styles.card}
      >
        {!!get(parsedImage, 'value') && (
          <Picture
            fallBack={FallBackImage}
            fallbackAlt={`${t(LOCATION_IMG.FIRST.DICTIONARY_KEY)} ${Name}`}
            image={parsedImage}
            imageCss={styles.image}
            imageSizes={imageSizes}
            isClientLink
          />
        )}
        <div className="result-cards-info" css={styles.cardInfo}>
          <div css={styles.titleAddress}>
            <h2 css={styles.cardTitle}>{truncate(Name, { length: 38 })}</h2>
            <p css={styles.cardAddress}>{truncate(Address, { length: 88 })}</p>
          </div>
          {Solution && renderSolutionItem(Solution)}
        </div>
      </a>
    );
  }
}
MapCard.displayName = 'RichFiltering/RichFilteringGrid/MapCard';

MapCard.defaultProps = {
  fields: defaultData,
  t: key => `dict-${key}`,
};

MapCard.propTypes = {
  Location: PropTypes.shape({
    Address: PropTypes.string,
    FallBackImage: PropTypes.object,
    ImageUrl: PropTypes.string,
    Name: PropTypes.string,
    Url: PropTypes.string,
  }),
  Solution: PropTypes.shape({
    Name: PropTypes.string,
    Price: PropTypes.number,
    Currency: PropTypes.string,
    PriceUnit: PropTypes.string,
  }),
};

export default withNamespaces()(MapCard);
